module.exports = __webpack_public_path__ + "static/media/online-money-transfer.ef100012.gif";